import { db } from './../config/Fire';
import * as Constants from './../constants/nodes_database';

export const SET_RESERVE_CONFIGURATIONS_RESTAURANT_USER = 'SET_RESERVE_CONFIGURATIONS_RESTAURANT_USER';
export const SAVING_RESTAURANT = 'SAVING_RESTAURANT';
export const SAVED_RESTAURANT = 'SAVED_RESTAURANT';

const setReserveConfigurationsRestaurantUser = payload => ({ type: SET_RESERVE_CONFIGURATIONS_RESTAURANT_USER, payload });
export const setSavingRestaurant = payload => ({ type: SAVING_RESTAURANT, payload });
export const setSavedRestaurant = payload => ({ type: SAVED_RESTAURANT, payload });

export const setReserveConfigurationsToRestaurant = payload => {
    return dispatch => {
        var isSavingRestaurant = true;
        dispatch(setSavingRestaurant(isSavingRestaurant));
        const { id, totalCapacity, reservationCapacity, automaticReservations, minPlacesPerReservation, maxPlacesPerReservation, averageReservationTime, minimumPreviousReservationHours, maximumPreviousReservationDays, reservePreviousCancellationTime } = payload;
        if(id) {
            return db.ref(`${Constants.RESTAURANTS}/${id}`).update({
                totalCapacity,
                reservationCapacity,
                automaticReservations,
                minPlacesPerReservation,
                maxPlacesPerReservation,
                averageReservationTime,
                minimumPreviousReservationHours,
                maximumPreviousReservationDays,
                reservePreviousCancellationTime,
            })
            .then(() => {
                //console.log("getRestaurant: " + JSON.stringify(restaurant));
                dispatch(setReserveConfigurationsRestaurantUser(payload));
                var isSavedRestaurant = true;
                dispatch(setSavingRestaurant(isSavingRestaurant = false));
                dispatch(setSavedRestaurant(isSavedRestaurant));
            })
            .catch(err => {
                console.log("not found save data");
                dispatch(setSavingRestaurant(isSavingRestaurant= false));
            });
        } else {
            console.log("id undefined: ");
                dispatch(setSavingRestaurant(isSavingRestaurant= false));
        }
    };
};